const LATEST_NEWS_LIMIT = 3;
const TOP_NEWS_LIMIT = 1;

export { LATEST_NEWS_LIMIT, TOP_NEWS_LIMIT };
